import React, { useEffect } from 'react'
import { Modal, Row, Col, App, Button, Space} from 'antd'
import { useState } from 'react'
import classes from './expense.module.css'
import { useFeiyongUpdateQuery, useFYchaosongMutation, useFeiyongZTXGMutation } from '../../store/DianShangYeWuApi'
import StateTag from '../../cpn/StateTag';
import ExpenseNodeCheck from './ExpenseNodeCheck'
import Asterisk from '../../cpn/Asterisk'
import ReportCheck from '../report/ReportCheck'
import ClientCheck from '../../system/client/ClientCheck'
import DocumentRule from '../../cpn/DocumentRule'
import Icon from '../../cpn/Icon'
import FilePreview from '../../cpn/FilePreview'
import { usePrintModal } from '../../cpn/usePrintModal'
import ExpenseWithdraw from './ExpenseWithdraw'
import ExpenseFinanceAmount from './ExpenseFinanceAmount'
import ExpenseFinanceZFLX from './ExpenseFinanceZFLX'
import Copy from '../../cpn/Copy'
import AccountCheck from '../../system/account/AccountCheck';
function ExpenseCheck(props) {
    const yh_qx = props.yh_qx || '';
    const { message } = App.useApp();
    const [openCheck, setOpenCheck] = useState(false)
    const { handlePrint, modalRef } = usePrintModal(openCheck, '费用单')
    const [info, setInfo] = useState({
        fy_content: '',
        fy_ctime: '',
        fy_price: '',
        fy_uname: '',
        fy_num: '',
        fy_type_id: '',
        fy_type_name: '',
        fy_kh_id: '',
        fy_kh_name: '',
        fy_amount: '',
        fy_date: '',
        fy_date_end: '',
        fy_bzd_name: '',
        fy_bzd_danhao: '',
        fy_id: '',
        fy_yuedu: '',
        fy_state: '',
        fy_uid: '',
        fy_bzd_id: '',
        fy_month: '',
        fy_year: '',
        fy_state_time: '',
        fy_image_file:[],
        fy_image_name:[],
        fy_zflx: '',
        fy_qyyhzh_id: '',
        fy_qyyhzh_name: '',
        fy_qyyhzh_date: '',
    })
    const { data, isSuccess } = useFeiyongUpdateQuery({ fy_id: props.fy_id }, { skip: !openCheck, refetchOnMountOrArgChange: 1 })
    useEffect(() => {
        if (isSuccess && data.Status === 'success') {
            setInfo(prev=>({...prev,
                fy_content: data.Result.fy_content,
                fy_ctime: data.Result.fy_ctime,
                fy_price: data.Result.fy_price,
                fy_uname: data.Result.fy_uname,
                fy_num: data.Result.fy_num,
                fy_type_id: data.Result.fy_type_id,
                fy_type_name: data.Result.fy_type_name,
                fy_kh_name: data.Result.fy_kh_name,
                fy_kh_id: data.Result.fy_kh_id,                
                fy_amount: data.Result.fy_amount,
                fy_date: data.Result.fy_date,
                fy_date_end: data.Result.fy_date_end,
                fy_bzd_name: data.Result.fy_bzd_name,
                fy_bzd_danhao: data.Result.fy_bzd_danhao,
                fy_id: data.Result.fy_id,
                fy_yuedu: data.Result.fy_yuedu,
                fy_state: data.Result.fy_state,
                fy_uid: data.Result.fy_uid,
                fy_bzd_id: data.Result.fy_bzd_id,
                fy_month: data.Result.fy_month,
                fy_year: data.Result.fy_year,
                fy_state_time: data.Result.fy_state_time,
                fy_image_file: data.Result.fy_image_file,
                fy_image_name: data.Result.fy_image_name,
                fy_bm_name: data.Result.fy_bm_name,
                fy_bm_id: data.Result.fy_bm_id,
                fy_khyhzh_name: data.Result.fy_khyhzh_name,
                fy_khyhzh_id: data.Result.fy_khyhzh_id,
                fy_zflx: data.Result.fy_zflx,
                fy_qyyhzh_id: data.Result.fy_qyyhzh_id,
                fy_qyyhzh_name: data.Result.fy_qyyhzh_name,
                fy_qyyhzh_date: data.Result.fy_qyyhzh_date,
            }))
        }
    }, [data, isSuccess])
    //取消提交
    // const [ztxg] = useJiekuanZTXGMutation()
    // const [isSubmitting, setIsSubmitting] = useState(false)
    const formatCurrency = (value) => {
        if (value === null || value === undefined) return '0.00';
        return `￥${Number(value).toLocaleString('zh-CN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }
    //抄送
    const [fyChaosong] = useFYchaosongMutation()
    //取消提交
    const [ztxg] = useFeiyongZTXGMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
           <a 
                type='check' 
                onClick={() => { 
                    if(props.fy_sp_state==='2' && props.fy_sp_jd_name==='抄送'){
                        fyChaosong({
                            'fy_sp_id': props.fy_sp_id,     //抄送节点id
                            'fy_id': props.fy_id,
                            'fy_sp_yh_id': props.fy_sp_yh_id   //抄送人id
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('抄送成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('抄送失败'+res.data.Message)
                            }
                        })
                    }else if(props.fy_state === '5' && props.fy_uid === props.yh_id){
                        ztxg({
                            fy_id:props.fy_id,
                            fy_state: '6',
                        }).then((res) => {
                            if(res.data.Status === 'success'){
                                message.success('已读标记成功')
                                setOpenCheck(true);  
                            }else{
                                message.error('已读标记失败'+res.data.Message)
                            }
                        })
                    }else{
                        setOpenCheck(true);  
                    }
                }} 
            >
                {(props.fy_sp_state==='2' && props.fy_sp_jd_name==='抄送')&&<span style={{color:"red"}}>未读：</span>}
                {(props.fy_state==='5' && props.fy_uid === props.yh_id && props.listType === 'submitted')&&<span style={{color:"red"}}>未读：</span>}
                {props.fy_state==='4'&&<span style={{color:"red"}}>已驳回：</span>}
                {props.fy_sp_fy_kh_name?props.fy_sp_fy_kh_name:props.fy_kh_name}
            </a>
            <Modal
                open={openCheck}
                onCancel={() => setOpenCheck(false)}
                onOk={() => setOpenCheck(false)}
                width={1330}
                footer={[
                    <Button key="print" type="primary" onClick={handlePrint}>
                        打印
                    </Button>,
                    <Button key="close" onClick={() => setOpenCheck(false)}>
                        关闭
                    </Button>
                ]}
            >
                <div ref={modalRef}>
                <Row style={{width:"1280px"}}>
                   {(info.fy_state === '5' || info.fy_state==='6') && <div style={{ position: 'absolute', top: 0, right: 0, zIndex: 10 }}>
                        <img src={'./img/expenseFinished.png'} alt="费用单" width={150} height={150}/>
                    </div>} 
                    <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #3366cc',borderLeft:'3px solid #3366cc'}}></Col>
                    <Col span={16} className={classes.row_top_middle} style={{color:'#3366cc',borderTop:'3px solid #3366cc'}}>费用单</Col>
                    <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #3366cc',borderRight:'3px solid #3366cc'}}></Col>
                    {/* 第一行 */}
                    <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #3366cc',color:'#3366cc'}}>团队名称</Col>
                    <Col span={6}  className={classes.col_top_input} style={info.fy_bzd_name ? {} : {padding: '15px'}}>
                        <ReportCheck dsbzd_id={info.fy_bzd_id} dsbzd_name={info.fy_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>  
                    <Col span={2} className={classes.col_top_label} >团队客户类型</Col>
                    <Col span={6}  className={classes.col_top_input}>
                        {info.fy_type_name}
                    </Col>  
                    <Col span={2}  className={classes.col_top_label} >团队客户</Col>
                    <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #3366cc'}}>
                        <ClientCheck kh_id={info.fy_price} kh_name={info.fy_num} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col> 
                    {/* 第二行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 日期</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.fy_date}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/>金额</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {formatCurrency(info.fy_amount)}
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 部门</Col>
                    <Col span={6}  className={classes.col_middle_right_input}   style={{borderRight:'3px solid #3366cc'}}>
                        {info.fy_bm_name}
                    </Col>
                    {/* 第三行 */}
                    <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #3366cc'}}><Asterisk color='red'/> 费用客户</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        <ClientCheck kh_id={info.fy_kh_id} kh_name={info.fy_kh_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
                    </Col>
                    <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 银行账户</Col>
                    <Col span={14}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #3366cc'}}>
                        {info.fy_khyhzh_name}
                    </Col>
                     {/* 第四行       */}
                     <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}><Asterisk color='red'/> 往来类型</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                        {info.fy_zflx}
                    </Col>                                   
                    <Col span={2} className={classes.col_middle_label}>备注</Col>
                    <Col span={6}  className={classes.col_middle_input}><Copy title={info.fy_content} /></Col>  
                    <Col span={2} className={classes.col_middle_label}>转账记录</Col>
                    <Col span={6}  className={classes.col_middle_input} style={{borderRight:'3px solid green'}}>
                        {info.fy_qyyhzh_date} <AccountCheck qyyhzh_id={info.fy_qyyhzh_id} name={info.fy_qyyhzh_name} />
                    </Col>                                   
                    {/* 第五行       */}
                    <Col span={2} className={classes.col_middle_label} style={{borderLeft:'3px solid green'}}>编号/状态</Col>
                    <Col span={6}  className={classes.col_middle_input}>
                    {props.fy_id}&emsp;<StateTag state={info.fy_state} />
                    </Col>                                   
                    <Col span={2} className={classes.col_middle_label}>附件</Col>
                    <Col span={14}  className={classes.col_bottom_input} style={{borderRight:'3px solid green'}}>
                        <FilePreview 
                            fileNames={info.fy_image_file} 
                            fileUrls={info.fy_image_name} 
                        />
                    </Col>   
                    {/* 第六行 */}
                    <Col span={24} className={classes.bottom_row}>
                        <ExpenseNodeCheck 
                            fy_id={props.fy_id} 
                            qy_id={props.qy_id} 
                            user_id={props.yh_id} 
                            yh_id={props.yh_id}
                            yh_name={props.yh_name} 
                            qy_name={props.qy_name}
                            fy_uname={info.fy_uname}
                            fy_ctime={info.fy_ctime}
                            fy_state_time={info.fy_state_time}
                        />
                    </Col>
                </Row> 
                <Row>
                    <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                        <DocumentRule/>
                        {(props.yh_id === props.fy_uid && props.fy_state ==='4') ? <Icon type='withdraw' onClick={() => {
                                                                                                // 如果正在提交中，直接返回
                                                                                                if (isSubmitting) {
                                                                                                    return;
                                                                                                }
                                                                                                
                                                                                                // 设置提交状态
                                                                                                setIsSubmitting(true);                                                                                                
                                                                                                ztxg({
                                                                                                    fy_id:props.fy_id,
                                                                                                    fy_state: '1',
                                                                                                }).then((res) => {
                                                                                                    if(res.data.Status === 'success') {
                                                                                                        message.success('费用单取消提交成功！')
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }else{
                                                                                                        message.error('费用单取消提交失败！'+res.data.Message)
                                                                                                        setOpenCheck(false);
                                                                                                        setIsSubmitting(false);
                                                                                                    }
                                                                                                    // 3秒后恢复可点击状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                }).catch((err) => {
                                                                                                    // 出错时也要恢复状态
                                                                                                    setTimeout(() => {
                                                                                                        setIsSubmitting(false);
                                                                                                    }, 3000);
                                                                                                })
                                                                                            }} /> : null}
                        {yh_qx.includes('管理') ? <Space size={20}>
                            <ExpenseWithdraw fy_id={props.fy_id} fy_cw_content={info.fy_cw_content} fy_amount={info.fy_amount}/>
                            <ExpenseFinanceAmount fy_id={props.fy_id} fy_state={info.fy_state} fy_cw_content={info.fy_cw_content} fy_amount={info.fy_amount} />
                            <ExpenseFinanceZFLX fy_id={props.fy_id} fy_zflx={info.fy_zflx} />
                        </Space> : null}
                    </Col>
                </Row>
                </div>
            </Modal>
        </>
    )
}

export default ExpenseCheck